let React =     require("react");
let UnitConversions = require("../../cio-config/unitConversions.js");
let MetaProperties = require("../../cio-config/metaProperties.js");

class MetaDataPackageCard extends React.Component {
    convertToMM(value){ 
        if(!value){ return false };    
        return `${UnitConversions.Micrometers.toMillimeters(value)} mm`; 
    }

    render() {
        const naString = "n/a";
        const { pins, pitch, body_length, body_width, height, lead_span, lead_span2, pitch2, ipc_family: ipc} = this.props.data;
        const { show } = this.props
        const ipcFamily = MetaProperties.getEnumFromNumber("package", "ipcFamily", ipc);

        return <div className={`metaDataPackageCard ${show ? "show": ""}`}>
                    <div><span className="name">ipc:</span>        {ipcFamily && ipcFamily.key || naString}</div>
                    <div><span className="name">pins:</span>       {pins || "n/a"}</div>
                    <div><span className="name">pitch:</span>      {this.convertToMM(pitch) || naString}</div>
                    <div><span className="name">pitch2:</span>     {this.convertToMM(pitch2) || naString}</div>
                    <div><span className="name">body_length:</span>{this.convertToMM(body_length) || naString}</div>
                    <div><span className="name">body_width:</span> {this.convertToMM(body_width) || naString}</div>
                    <div><span className="name">height:</span>     {this.convertToMM(height) || naString}</div>
                    <div><span className="name">lead_span:</span>  {this.convertToMM(lead_span) || naString}</div>
                    <div><span className="name">lead_span2:</span> {this.convertToMM(lead_span2) || naString}</div>
                </div>
    }
}

module.exports = MetaDataPackageCard;
